module.exports = __webpack_public_path__ + "static/media/leonSign.3ab41f9c.png";